import { render, staticRenderFns } from "./StarshipNavigation.vue?vue&type=template&id=5af23290&lang=pug&"
import script from "./StarshipNavigation.vue?vue&type=script&lang=ts&"
export * from "./StarshipNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports